import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { IFormData } from "./types";

export const createTask = async (formData: IFormData) => {
  try {
    const data = await apiClientSource.post("/task-service/api/tasks/create", formData)
    return data;
  } catch (error) {
    handleAxiosError(error, "Error al crear el proyecto");
  }
};
